import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

export const useTransition = () => {
  const nodeRef = useRef<HTMLElement>(null!)
  const { contextSafe } = useGSAP({ scope: nodeRef })
  const active = useRef(false)

  const handleTransitionLeave = contextSafe(() => {
    active.current = false
  })

  const handleTransitionEnter = contextSafe(() => {
    active.current = true
  })

  const handleEndListener = contextSafe(async (done: () => void) => {
    const timeline = gsap.timeline({ onComplete: done })
    !active.current
      ? timeline.to(nodeRef.current, { opacity: 0, duration: 0.5, ease: 'power2.inOut' })
      : timeline.to(nodeRef.current, { opacity: 1, duration: 0.5, ease: 'power2.inOut' })
  })

  return { nodeRef, handleTransitionEnter, handleTransitionLeave, handleEndListener }
}
